import React from 'react';
import styled from 'styled-components';
import { SlidePage } from '../index';
import { BodyContainer, Span, ProgressBox, ProgressStat } from '../styles';
import { polarColors } from '../constants';
import icono from '../imgs/icons/edu_iconos_binoculars.svg';

const getColor = value => {
  if (value < 25) {
    return polarColors[4];
  }
  if (value < 50) {
    return polarColors[3];
  }
  if (value < 75) {
    return polarColors[1];
  }
  return polarColors[0];
};

const IncertidumbreTransicion = ({ user, background, number }) => {
  // const iata = (parseFloat(user['IATA']) / 5) * 100;
  // const iataContext = (parseFloat(user['IATA_CON']) / 5) * 100;
  const iataRend = (parseFloat(user['IATA_REN']) / 5) * 100;
  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h2>4.2. Rendimiento y futuro</h2>
          <p className='justified'>
            Este puntaje muestra tu nivel de preocupación ante las mayores
            demandas académicas que puede implicar el paso a la educación media
            (por mayor dificultad, mayor exigencia o mayor importancia de las
            notas en esta etapa), así como por tener que comenzar a decidir
            sobre lo que harás al terminar el colegio:
          </p>
          <div className='progress-info-group' style={{ marginTop: 36 }}>
            <div className='progress-info'>
              <div className='progress-details-single'>
                <ProgressBox
                  progress={iataRend}
                  backColor={() => getColor(iataRend)}
                >
                  <div className='progress'></div>
                </ProgressBox>
                <ProgressStat>{iataRend.toFixed(0)}</ProgressStat>
              </div>
            </div>
          </div>
          <br />
          <br />
          <br />
          <br />
          <div style={{ position: 'relative' }}>
            <div style={{ position: 'absolute', top: -45, left: -25 }}>
              <img
                src={icono}
                alt='icono binoculares'
                style={{ width: 100, height: 'auto' }}
              />
            </div>
            <div className='edu-bubble-group bg-edu-red'>
              <p className='justified'>
                Recuerda que es normal sentir nervios y preocupación en la nueva
                etapa que se inicia, esto puede ser señal de que tu mente está
                activa y comprometida con tu crecimiento y desarrollo.{' '}
                <strong>
                  Lo importante es aprender a manejar estos sentimientos de
                  manera constructiva
                </strong>
                , especialmente si alcanzaste puntajes altos. Para esto, es
                recomendable tomarse un tiempo para{' '}
                <strong>reflexionar sobre lo que te preocupa</strong> y por qué.
                También, <strong>compartir tus preocupaciones</strong> con
                amigos/as y familiares puede aliviar su peso y ayudarte a
                encontrar soluciones, así como{' '}
                <strong>
                  hablar con tus profesores u orientador/a, quienes pueden
                  ayudarte y ofrecerte orientación personalizada
                </strong>
                .
              </p>
            </div>
          </div>
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default IncertidumbreTransicion;
